import React from 'react';
import { findDOMNode } from 'react-dom';
import { isMobile } from 'react-device-detect';
import { TweenMax, TimelineLite } from 'gsap';

export default {

    initialise(sqField) {
        this.sqField = sqField;
        if (sqField) {
            this.inlineLoader = sqField.getElementsByClassName('inline-loader')[0];
            this.loader = sqField.getElementsByClassName('loader')[0];
            this.success = sqField.getElementsByClassName('success')[0];        
            this.message = sqField.getElementsByClassName('message')[0];
            this.progress = sqField.getElementsByTagName('progress')[0];
        }
    },

    showLoader(sqField) {
        this.initialise(sqField);
        if (sqField) {
            this.hideSuccess();
            this.loader.style.display = 'block';
            TweenMax.to(window, 0.5, {scrollTo: (sqField.offsetTop - 140)});    
        }
    },

    showInlineLoader(sqField) {
        this.initialise(sqField);
        if (sqField) {
            this.hideSuccess();
            this.inlineLoader.style.display = 'block';
        }
    },

    showSuccess(sqField) {
        this.initialise(sqField);
        if (sqField) {
            this.hideLoader();
            this.success.style.display = 'block';        
        }
    },

    showMessage(NbnPlans, sqField, type, message) {
        this.initialise(sqField);

        let NbnPlansNode = findDOMNode(NbnPlans);

        this.message.classList.remove('nbn-yes', 'nbn-no');
        this.message.classList.add(type);
        this.message.getElementsByTagName('div')[0].innerHTML = message;

        TweenMax.fromTo(this.message, 1, {height: '0', display: 'flex'}, {height: (isMobile ? '110px' : '75px'), ease: Elastic.easeOut.config(1, 0.3)});
        if (isMobile) {
            TweenMax.to(NbnPlansNode.getElementsByClassName('nbn-contracts')[0], 0.3, {css: {marginTop: '0px'}});
        }
    },

    hideLoader() {
        this.loader.style.display = 'none';
    },

    hideSuccess() {
        this.success.style.display = 'none';
    },

    hideInlineLoader(sqField) {
        this.initialise(sqField);
        this.inlineLoader.style.display = 'none';
    },

    hideMessage(sqField) {
        this.initialise(sqField);

        let tl = new TimelineLite();
        tl.to(this.message, 0.5, {height: 0});
        tl.set(this.message, {display: 'none'});

        this.message.getElementsByTagName('div')[0].innerHTML = '';
    },

    resetSq(sqField) {
        this.initialise(sqField);

        this.hideSuccess();
        this.hideLoader();
    },

	triggerProgressBar(sqField) {
		this.initialise(sqField);

		let tl = new TimelineLite();

		tl.set(this.progress, {value: 0});
		tl.to(this.progress, 0.25, {height: '20px'});
		tl.to(this.progress, 8, {value: 60, ease: Power1.easeInOut});
		tl.to(this.progress, 16, {value: 99, ease: Power1.easeOut});

		return tl;
	},

	completeLoader(sqField, tl) {
		this.initialise(sqField);

    	tl.pause();
    	TweenMax.to(this.progress, 0.25, {height: 0, value: 100});
	}

};


// WEBPACK FOOTER //
// ./resources/assets/js/nbn/Nbn/sqAnimations.js